import { render, staticRenderFns } from "./RandomQuestions.vue?vue&type=template&id=26880820&"
import script from "./RandomQuestions.vue?vue&type=script&lang=js&"
export * from "./RandomQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports